export default __webpack_public_path__ + "static/media/operations.39e9b392.png";